import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../app/providers/AuthProvider';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
import { Logo } from '../components/Logo';
import { COLORS } from '../../../core/constants/colors';

export const VerifyEmailPage: React.FC = () => {
  const { confirmSignup } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [code, setCode] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const emailParam = searchParams.get('email');
    if (emailParam) {
      setEmail(decodeURIComponent(emailParam));
    } else {
      navigate('/signup');
    }
  }, [searchParams, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await confirmSignup({ email, code });
      navigate('/login?verified=true');
    } catch (err: any) {
      setError(err.message || 'Verification failed. Please check your code.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ backgroundColor: COLORS.extended.cultured }}
    >
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-10">
          <Logo />
          
          <div className="text-center mb-8">
            <h1
              className="text-3xl md:text-4xl font-bold mb-2"
              style={{ color: COLORS.primary.persianIndigo }}
            >
              Verify Email
            </h1>
            <p
              className="text-sm"
              style={{ color: COLORS.primary.persianIndigo, opacity: 0.7 }}
            >
              We've sent a verification code to<br />
              <strong>{email}</strong>
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <Input
              label="Verification Code"
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Enter 6-digit code"
              required
            />

            {error && (
              <div
                className="mb-4 p-3 rounded-lg"
                style={{ backgroundColor: COLORS.extended.redSalsa + '20' }}
              >
                <p className="text-sm" style={{ color: COLORS.extended.redSalsa }}>
                  {error}
                </p>
              </div>
            )}

            <Button type="submit" disabled={loading}>
              {loading ? 'Verifying...' : 'Verify Email'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <span
              className="text-sm"
              style={{ color: COLORS.primary.persianIndigo, opacity: 0.7 }}
            >
              Didn't receive the code?{' '}
            </span>
            <button
              className="text-sm font-semibold hover:underline"
              style={{ color: COLORS.user.queryButton }}
            >
              Resend
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};